import React from 'react';
import { number, string } from 'prop-types';
import DateTime from '../DateTime/DateTime';
import numeral from 'numeral';

const propTypes = {
  create_ts: number.isRequired,
  hold: number.isRequired,
  balance: number.isRequired,
  currency: string.isRequired,
  comment: string,
};

const defaultProps = {
  create_ts: 0,
};

const renderNumber = (number) => {
  const num = numeral(number).format('+0,000.00');

  if (number > 0) {
    return (
      <span className="text-success">
        {num}
      </span>
    );
  } else if (number < 0) {
    return (
      <span className="text-danger">
        {num}
      </span>
    );
  } else {
    return (
      <span>
        {'0.00'}
      </span>
    );
  }




};

const PaymentDataListItem = ({ create_ts, hold, balance, currency, comment }) => (
  <tr className="payment-item">
    {/* дата */}
    <td>
      <DateTime timestamp={create_ts} />
    </td>
    {/* холд */}
    <td className='text-right'>{renderNumber(hold)}</td>
    {/* баланс */}
    <td className='text-right'>{renderNumber(balance)}</td>
    {/* валюта */}
    <td>{currency}</td>
    {/* комментарий */}
    <td>{comment}</td>
  </tr>
);

PaymentDataListItem.propTypes = propTypes;
PaymentDataListItem.defaultProps = defaultProps;

export default PaymentDataListItem;
